var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('side-nav'),_c('b-container',{class:_vm.sideNav.active == true ? 'myBlur' : '',attrs:{"fluid":"","id":"appContent"}},[_c('router-view')],1),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }